<template>
  <section class="container enquiry-form">
    <el-row type="flex" justify="center">
      <el-col :lg="20" :md="20" :sm="20" :xs="22">
        <!-- <ShowProductDetails v-if="singleProduct" :product="singleProduct"/> -->
        <MakePayment @checkout:show="showCheckout" v-if="show_make_payment" />
        <el-alert
          v-if="success_message"
          :title="success_message"
          type="success"
          class="success-message"
        ></el-alert>
        <div v-if="!show_make_payment" class="product-enquiry-form mt-20">
          <el-row>
            <el-col :lg="24" :xs="24">
              <el-form ref="form" :model="form" label-position="top" v-if="form" id="checkout-form">
                <!-- shipping details -->
                <el-row>
                  <div class="section-heading">
                    <h3>Shipping Details</h3>
                  </div>
                  <el-row>
                    <el-checkbox
                      class="mb-10"
                      v-model="show_billing"
                    >Shipping address same as billing address</el-checkbox>
                  </el-row>
                  <el-row :gutter="30">
                    <el-col :md="8">
                      <el-form-item>
                        <el-input v-model="form.name" placeholder="Full Name"></el-input>
                        <p class="error" v-if="getErrors && getErrors.name">
                          {{
                          getErrors.name }}
                        </p>
                      </el-form-item>
                    </el-col>
                    <el-col :md="8">
                      <el-form-item>
                        <el-input v-model="form.email" placeholder="Email"></el-input>
                        <p class="error" v-if="getErrors && getErrors.email">
                          {{
                          getErrors.email }}
                        </p>
                      </el-form-item>
                    </el-col>
                    <el-col :md="8">
                      <el-form-item>
                        <el-input
                          type="text"
                          v-model="form.mobile"
                          :maxlength="9"
                          pattern="/d"
                          placeholder="+6412345678"
                        ></el-input>
                        <p class="error" v-if="getErrors && getErrors.mobile">{{ getErrors.mobile }}</p>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="30">
                    <el-col :md="24">
                      <el-form-item>
                        <el-input
                          type="textarea"
                          :autosize="{ minRows: 5, maxRows: 4}"
                          placeholder="Shipping Address"
                          v-model="form.address"
                        ></el-input>
                        <p
                          class="error"
                          v-if="getErrors && getErrors.address"
                        >{{ getErrors.address }}</p>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-row>
                <!-- ./shipping details -->
                <!-- billing details  -->
                <el-row v-if="!show_billing">
                  <div class="section-heading">
                    <h3>Billing Details</h3>
                  </div>
                  <el-row :gutter="30">
                    <el-col :md="8">
                      <el-form-item>
                        <el-input v-model="form.billing_name" placeholder="Full Name"></el-input>
                        <p class="error" v-if="getErrors && getErrors.billing_name">
                          {{
                          getErrors.billing_name }}
                        </p>
                      </el-form-item>
                    </el-col>
                    <el-col :md="8">
                      <el-form-item>
                        <el-input v-model="form.billing_email" placeholder="Email"></el-input>
                        <p
                          class="error"
                          v-if="getErrors && getErrors.billing_email"
                        >{{ getErrors.billing_email }}</p>
                      </el-form-item>
                    </el-col>
                    <el-col :md="8">
                      <el-form-item>
                        <el-input
                          type="text"
                          v-model="form.billing_mobile"
                          :maxlength="9"
                          pattern="/d"
                          placeholder="+6412345678"
                        ></el-input>
                        <p
                          class="error"
                          v-if="getErrors && getErrors.billing_mobile"
                        >{{ getErrors.billing_mobile }}</p>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="30">
                    <el-col :md="24">
                      <el-form-item>
                        <el-input
                          type="textarea"
                          :autosize="{ minRows: 5, maxRows: 4}"
                          placeholder="Shipping Address"
                          v-model="form.billing_address"
                        ></el-input>
                        <p
                          class="error"
                          v-if="getErrors && getErrors.billing_address"
                        >{{ getErrors.billing_address }}</p>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-row>
                <!-- ./billing details -->
                <!-- bank transaction number -->
                <el-row :gutter="30" v-if="form.order_type !== 'stripe' ">
                  <el-col :md="24">
                    <el-form-item>
                      <el-input
                        v-model="form.transaction_ref_no"
                        placeholder="Bank transaction Number"
                      ></el-input>
                      <p class="error" v-if="getErrors && getErrors.transaction_ref_no">
                        {{
                        getErrors.transaction_ref_no }}
                      </p>
                    </el-form-item>
                  </el-col>
                </el-row>
                <!-- ./ bank transaction number -->
                <!-- payment mode -->
                <el-col :md="24">
                  <el-radio v-model="form.order_type" label="stripe">Pay online ( Stripe )</el-radio>
                  <el-radio v-model="form.order_type" label="offline">Bank Transfer</el-radio>
                </el-col>
                <!-- payment mode -->
                <!-- notification for bank transfer -->
                <el-col v-if="form.order_type !== 'stripe' ">
                  <notice-component v-if="form.order_type !== 'stripe' " />
                </el-col>
                <!-- ./ notification for bank transfer -->
                <!-- button -->
                <el-col :md="24">
                  <el-form-item>
                    <el-button
                      type="primary"
                      @click="onSubmit"
                      :loading="loading"
                      class="btn submit-btn"
                    >{{ formBtnText }}</el-button>
                  </el-form-item>
                </el-col>
                <!-- ./ button -->
              </el-form>
            </el-col>
          </el-row>
        </div>
        <el-alert v-if="error_message" :title="error_message" type="error"></el-alert>
      </el-col>
    </el-row>
  </section>
</template>

<script>
import progress from "nprogress";
import { mapGetters } from "vuex";
import NoticeComponent from "../shared/NoticeComponent";
import MakePayment from "./MakePayment";

export default {
  name: "CheckoutComponent",
  data() {
    return {
      show_make_payment: false,
      form: {
        items: [],
        name: "",
        email: "",
        mobile: "",
        address: "",
        billing_name: "",
        billing_email: "",
        billing_mobile: "",
        billing_address: "",
        transaction_ref_no: "",
        order_type: "stripe"
      },
      singleProduct: "",
      image: {},
      success_message: "",
      show_billing: true,
      loading: false,
      error_message: ""
    };
  },
  components: {
    MakePayment,
    NoticeComponent
  },
  computed: {
    ...mapGetters("products", ["getSingleProduct"]),
    ...mapGetters("payments", ["getStripe"]),
    ...mapGetters("orders", ["getOrder"]),
    ...mapGetters("errors", ["getErrors", "getMessage"]),
    ...mapGetters("cart", ["getCart"]),
    ...mapGetters("auth", ["getAuthenticatedUser"]),
    slug() {
      return this.$route.params.slug;
    },
    formBtnText() {
      return this.order_type === "stripe" ? "Proceed to Pay" : "Place Order";
    }
  },
  async created() {
    await this.fetchSingleProduct();
  },
  methods: {
    showCheckout() {
      this.show_make_payment = false;
    },
    async fetchSingleProduct() {
      progress.start();
      this.form.product_id = this.singleProduct.id;
      this.form.name = this.getAuthenticatedUser.name;
      this.form.mobile = this.getAuthenticatedUser.mobile;
      this.form.email = this.getAuthenticatedUser.email;
      //   await this.$store.dispatch("products/fetchSingleProduct", this.slug);
      progress.done();
      if (this.getSingleProduct) {
        this.singleProduct = this.getSingleProduct;
        this.image = this.getSingleProduct.images[0];
      }
    },
    async onSubmit() {
      progress.start();
      this.loading = true;
      this.form.product_id = this.singleProduct.id;
      this.form.show_billing = this.show_billing;
      this.form.items = this.getCart.map(item => {
        return { product_id: item.details.id, qty: item.qty }
      });
      await this.$store.dispatch("orders/store", this.form);
      this.loading = false;
      progress.done();
      if (this.getErrors.error) {
        this.error_message = this.getErrors.error;
        return
      }
      if (this.form.order_type !== "stripe") {
        this.success_message = this.getMessage;
        await this.$store.dispatch("checkout/clearCheckout");
        this.resetForm();
      } else if (this.getOrder && this.getStripe) {
        this.show_make_payment = true;
      }
    },
    resetForm() {
      this.form.address = "";
      this.form.transaction_ref_no = "";
      this.form.order_type = "stripe";
    }
  }
};
</script>

<style lang="scss" scoped>
.success-message {
  margin-bottom: 15px;
  color: black !important;
  text-align: center;
  font-weight: bold;
}

@media (max-width: 576px) and (min-width: 0px) {
  .enquiry-form .product-details .product-image img {
    width: 100% !important;
  }
}

.enquiry-form {
  padding: 1em 0 4rem 0;
  font-family: "Work Sans", sans-serif;

  .section-heading {
    margin-bottom: 15px;

    h3 {
      font-size: 28px;
      line-height: 31px;
      text-transform: uppercase;
      color: #11233f;
    }
  }

  .product-enquiry-form {
    input::placeholder {
      font-family: "Work Sans", sans-serif;
    }

    .submit-btn {
      background: #12ab0f;
      border-radius: 6px;
      float: right;
      padding: 12px 55px;
      font-style: normal;
      font-weight: bold;
      font-family: "Work Sans", sans-serif;
      outline: none;
    }
  }
}

@media (min-width: 0px) and (max-width: 576px) {
  .enquiry-form {
    padding: 2em 0;

    .product-enquiry-form {
      margin-top: 50px !important;
    }

    .section-heading {
      h3 {
        font-size: 18px !important;
      }
    }

    .product-details {
      .el-row {
        flex-wrap: wrap;
      }

      .product-image {
        img {
          width: 60px !important;
        }
      }

      .product-content h3 {
        font-size: 1em !important;
      }

      .product-price {
        margin-top: 15px;
        text-align: center;

        p {
          font-size: 1.4em !important;
        }
      }
    }
  }
}
</style>
